import RingOfFortune from '../../components/Games/RingOfFortune';

const RingOfFortunePage = () => {
  return <RingOfFortune />;
};

export default RingOfFortunePage;
